<template>
  <div>
    <div>
      <list-btn-sm  class="mr-1" @click="$emit('list')">목록</list-btn-sm>
      <save-btn-sm class="mr-1" @click="onSave">저장</save-btn-sm>
      <delete-btn-sm class="mr-1" @click="onDelete">삭제</delete-btn-sm>
    </div>
    <div>
      <mdb-input v-model="subject.name" label="과목명" icon="chalkboard-teacher"/>
      <table>
        <tr>
          <td class="pr-4" colspan="3">
            <label>
              <input type="checkbox" v-model="subject.portfolio"/>
              포트폴리오 여부
            </label>
            <label class="ml-4">
              <input type="checkbox" v-model="subject.noTest"/>
              평가 없음 여부(특강인 경우 체크)
            </label>
          </td>
        </tr>
        <tr>
          <td colspan="3"><mdb-badge class="p-1 mr-3" style="font-size:14px">평가 비율 </mdb-badge>
            필답 평가: <input type="number" v-model="subject.evalRatio.writing" class="underline" style="width:50px"/>
            수행 평가: <input type="number" v-model="subject.evalRatio.perform" class="underline" style="width:50px"/>
            태도 평가: <input type="number" v-model="subject.evalRatio.attitude" class="underline" style="width:50px"/>
            포트폴리오: <input type="number" v-model="subject.evalRatio.portfolio" class="underline" style="width:50px"/>
          </td>
        </tr>
        <tr>
          <td class="pb-2">
            <label-select label="훈련 유형" v-model="subject.lectureType">
              <option>이론</option>
              <option>실기</option>
              <option>이론 및 실기</option>
            </label-select>
          </td>
          <td class="pr-4"><date-picker v-model="subject.startDate" label="훈련 시작일"/></td>
          <td class="pr-4"><date-picker v-model="subject.endDate" label="훈련 종료일"/></td>
          <td class="pl-4"><mdb-input v-model="subject.totalHours" label="훈련 시간" style="width:80px"/></td>
          <!-- <td class="px-4"><date-picker v-model="subject.testDate" label="필답 평가일"/></td> -->
          <td></td>
        </tr>
      </table>
      <table v-for="(l , i) in subject.lectures" :key="i" class="w-100">
        <tr>
          <td class="bolder pr-3">
            <!-- <mdb-icon icon="chalkboard" /> {{l.name}} -->
            <mdb-input class="mb-1" v-model="l.name" label="단원명" icon="chalkboard"/>
          </td>
          <td >
            <mdb-input class="mb-1" type="number" v-model="l.hours" style="width:50px"/>
          </td>
        </tr>
        <tr><td class="pl-5 bolder">중단원</td></tr>
        <tr v-for="(u , ui) in l.units" :key="ui">
          <td class="pl-5">
            <input class="input-underline my-2 w-100" v-model="u.name"/>
          </td>
        </tr>
        <tr><td class="pl-5"><add-btn-sm @click="onAddUnit(l)" >중단원 추가</add-btn-sm></td></tr>
      </table>
      <add-btn-sm class="mt-3" @click="onAddLecture">단원 추가</add-btn-sm>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'NcsSubjectStructure',
  props: ['subject'],
  data: () => ({
  }),
  methods: {
    async onSave () {
      if (!confirm('저장할까요?')) return
      const subject = await this.subject.save()
      this.$emit('save', subject)
    },
    async onDelete (subject) {
      if (!confirm('삭제할까요?')) return
      await this.subject.delete()
      this.$emit('delete', this.subject)
    },
    onAddUnit (l) {
      l.units.push({ name: '새 중단원' })
    },
    onAddLecture () {
      this.subject.lectures.push({ name: '새 단원', hours: 0, units: [] })
    }
  },
  created () {
    if (this.subject) {
      if (!this.subject.evalRatio) {
        this.subject.evalRatio = {
          writing: 0, perform: 0, attitude: 0, portfolio: 0
        }
      }
    }
  }
}
</script>
